import React from "react";
import { InertiaLink } from "@inertiajs/inertia-react";

/**
 * ProductItem component that displays a single product in the shopping cart
 * Shows product information and action buttons (duplicate, edit, delete, parts list)
 *
 * @param {Object} props - Component props
 * @param {Object} props.product - Product data
 * @param {number} props.index - Product index in the list
 * @param {Function} props.onDuplicate - Function to duplicate product
 * @param {Function} props.onDelete - Function to delete product
 * @param {Function} props.onShowProductData - Function to show product details
 */
const ProductItem = ({
    product,
    index,
    onDuplicate,
    onDelete,
    onShowProductData
}) => {
    return (
        <div className="shoppingproduct d-flex">
            {/* Product information */}
            <div className="flex-grow-1">
                <p className="boldheading mb-2">
                    Product {index + 1}
                </p>
                <div className="shoppingproductattributes">
                    {product.properties ? (
                        <>
                            <p className="m-0">
                                Type:{" "}
                                {product.properties.type}{" "}
                                - Aantal variaties:{" "}
                                {product.variations.length}
                            </p>
                            <a
                                className="d-inline-block mt-2"
                                href="#"
                                onClick={(e) => onShowProductData(e, product)}
                            >
                                Toon productconfiguratie
                            </a>
                        </>
                    ) : (
                        <p className="m-0">
                            Nog geen configuratie
                        </p>
                    )}
                </div>
            </div>

            {/* Product action buttons */}
            <div className="shoppingproductedit d-flex justify-content-end align-items-center">
                {/* Duplicate button */}
                <a
                    name={"Dupliceren"}
                    href="#"
                    onClick={(e) => onDuplicate(e, product, index)}
                    className={"mr-2"}
                    title="Dupliceren"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        height="20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                        />
                    </svg>
                </a>

                {/* Parts list link */}
                <InertiaLink
                    name={`Stuklijst`}
                    href={`/${product.session_id}/${product.product_id}/ingave`}
                    className={"mr-2"}
                    title="Stuklijst"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        height="20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                        />
                    </svg>
                </InertiaLink>

                {/* Edit product link */}
                <InertiaLink
                    name={`${product.properties ? "opbouw/buitenlaag" : "panel"}`}
                    href={`/${product.session_id}/${product.product_id}/${product.properties ? "opbouw/buitenlaag" : "panel"}`}
                    className={"mr-2"}
                    title="Aanpassen"
                >
                    <svg
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        height="20"
                    >
                        <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                        <path
                            fillRule="evenodd"
                            d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                            clipRule="evenodd"
                        />
                    </svg>
                </InertiaLink>

                {/* Delete button */}
                <a
                    name={"Verwijder"}
                    href="#"
                    onClick={(e) => onDelete(e, product, index)}
                    title="Verwijder"
                >
                    <svg
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        height="20"
                    >
                        <path
                            fillRule="evenodd"
                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default ProductItem;
